import React from 'react';
import HubspotForm from 'react-hubspot-form';
import './login-help-form.scss';

const LoginHelpForm = () => {
  return (
    <div className="login-help-form">
      <HubspotForm portalId="8595083" formId="f9d9d715-397f-4043-856e-3c82778d40f0" />
    </div>
  );
};

export default LoginHelpForm;
